import * as inspections from 'serviceWorker/db/inspections/inspections';
import * as inspectionsService from 'serviceWorker/db/inspections/inspectionsService';
import { awaitEntities } from '../factories/awaitEntities';
import { InspectionEntity } from 'serviceWorker/repository/inspection/entity';
import { waitForInspections } from './waitForInspections';

/**
 * Gets only published (non-archived) inspections.
 * Used by analytics to exclude archived inspections from charts and calculations.
 */
export async function getPublishedInspections(): Promise<InspectionEntity[]> {
  await awaitEntities(inspectionsService, waitForInspections);
  return inspections.getPublished();
}
